import { Component, OnDestroy, OnInit, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ServiceAppEntityServiceRead } from '../../../openapi';
import { selectApplication, selectLoading, selectPending } from '../../../store/selectors/application.selectors';
import {selectServiceByUrl, selectUISettings} from '../../../store/selectors/app.selectors';
import { Store } from '@ngrx/store';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { UploaderAttachmentsService } from '../../../services/uploader-attachments.service';
import {
  loadApplication,
  loadPayments,
  loadServiceAttachmentPositions,
  setApplication,
  setPayments
} from '../../../store/actions/application.actions';
import { ContentComponent } from '../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { PdfGeneratorService } from '../../../services/pdf.generator.service';
import { AlertContainerComponent, AlertService } from '../../../common/alert-container/alert-container.component';
import { UppPreviewComponent } from './components/upp-preview/upp-preview.component';
import { ApplicationPreviewComponent } from '../application/common/application-preview/application-preview.component';
import {UISettings} from "../../../services/ssession.service";

@Component({
  selector: 'app-sent-preview-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    RouterModule,
    CommonModule,
    SpinnerComponent,
    AlertContainerComponent,
    UppPreviewComponent,
    ApplicationPreviewComponent
  ],
  providers: [UploaderAttachmentsService, PdfGeneratorService],
  templateUrl: './sent-preview-page.component.html'
})
export class SentPreviewPageComponent implements OnInit, OnDestroy {
  public applicationId: string | undefined =
    this.route.snapshot.params['appId'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> =
    this.store$.selectSignal(selectApplication);

  public contentUrl: string | undefined = this.route.snapshot.params['contentUrl'];

  public serviceType: Signal<ServiceAppEntityServiceRead | null> =
    this.store$.selectSignal(
      selectServiceByUrl(this.contentUrl || '')
    );

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public uiSettings: Signal<UISettings | null> = this.store$.selectSignal(selectUISettings);

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private alertService: AlertService
  ) {
  }

  public ngOnInit(): void {
    this.alertService.showByApplicationCode(history.state?.message);

    this.store$.dispatch(loadApplication({ id: this.applicationId || '' }));
    this.store$.dispatch(loadPayments({ applicationId: this.applicationId || '' }));
    this.store$.dispatch(loadServiceAttachmentPositions({ appId: this.applicationId || '' }));
  }

  public ngOnDestroy(): void {
    this.store$.dispatch(setApplication({ application: null }));
    this.store$.dispatch(setPayments({ applicationPayment: null }));
  }
}
